export const themeListOfTrends = {
    singleSort: '※項目をクリックすると単項目で並べ替えができます。',
    rank: '順位',
    category: 'カテゴリー',
    themeName: 'テーマ名',
    companyCount: '所属企業数',
    patentCount: '特許出願数',
    growthRatePatentCount: '特許出願数成長率',
    investmentAmount: '投資総額',
    growthRateInvestmentAmount: '投資成長率',
    businessAmount: 'ビジネス規模',
    analyzedThemeButton: '選択したテーマを分析する',
    defaultSortDescription:
        'デフォルトでは、ベクトル類似度の順位に沿ってソートされています。他の項目をクリックすると、その項目に沿った順位でソートされます。\nベクトル類似度の順位に戻したい場合は、キーワードを再入力して再検索してください。'
}
